import { C } from '../lib/theme';
import { fmtDate, daysBetween } from '../lib/util';

interface DeadlineIndicatorProps {
  deadline: string | null | undefined;
  label: string;
  now: string;
}

export function DeadlineIndicator({ deadline, label, now }: DeadlineIndicatorProps) {
  if (!deadline) return null;
  const d = new Date(deadline);
  const remaining = daysBetween(now, d);
  const color = remaining < 0 ? C.danger : remaining <= 3 ? C.warn : remaining <= 7 ? C.goldText : C.success;
  return (
    <div style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, display: 'inline-block' }} />
      <span style={{ color: C.textMuted }}>{label}:</span>
      <span style={{ color, fontWeight: 600 }}>{remaining < 0 ? `${Math.abs(remaining)}d overdue` : `${remaining}d remaining`}</span>
      <span style={{ color: C.textDim }}>({fmtDate(deadline)})</span>
    </div>
  );
}
